<div class="flex items-center gap-3 text-mild h-8">
  <span class="text-sm text-pale font-normal">
    {{ log.created_dt | shortDate }}
  </span>
  <span class="text-sm whitespace-pre-line">
    {{ log.content }}
  </span>
</div>